import { AlertCircle } from '@crehana/compass.icons.outline/v2/alert-circle';
import { Button } from '@crehana/compass.ui/v3/button';
import {
  PageLayout,
  PageLayoutContent,
  PageLayoutTop,
} from '@crehana/compass.web/page-layout';

import { useAddI18nLocales, useTranslation } from './i18n';

export const AdminAttendanceRequestsError = () => {
  useAddI18nLocales();
  const { t } = useTranslation();

  return (
    <PageLayout>
      <PageLayoutTop>
        <div className="tw-cds-font-heading-02 tw-cds-text-primary">
          {t('PAGE_TITLE')}
        </div>
      </PageLayoutTop>
      <PageLayoutContent>
        <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-cds-gap-4 tw-cds-p-8 tw-text-center">
          <div className="tw-cds-bg-layer-01 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-cds-p-5">
            <AlertCircle size={32} className="tw-cds-text-feedback-alert" />
          </div>
          <div className="tw-flex tw-flex-col tw-cds-gap-2">
            <h2 className="tw-cds-font-subtitle-03 tw-cds-text-primary">
              {t('ERROR_TITLE')}
            </h2>
            <p className="tw-cds-font-body-02 tw-cds-text-secondary tw-max-w-[48rem]">
              {t('ERROR_DESCRIPTION')}
            </p>
          </div>
          <Button
            type="button"
            variant="primary"
            onClick={() => window.location.reload()}
          >
            {t('BUTTON_RETRY')}
          </Button>
        </div>
      </PageLayoutContent>
    </PageLayout>
  );
};
